export const COMPANY_NUMBER = '(888) 582-7231';
export const COMPANY_INFO_EMAIL = 'info@marshallreddick.com';
